import './CardBlock.scss';

import { createApp, defineAsyncComponent } from 'vue';

const CardBlockVideo = defineAsyncComponent(
	() => import('./CardBlockVideo.vue'),
);

const mountingCardGridBlocks = document.querySelectorAll(
	'[data-feature="card-block-video"]:not([data-mount-vue="False"])',
);

if (mountingCardGridBlocks) {
	mountingCardGridBlocks.forEach((block) => {
		const app = createApp({
			name: 'CardBlockVideoApp',
		});
		app.component('card-block-video', CardBlockVideo);
		app.mount(block);
	});
}

